import axios from "../shared/axios";


export function getRegisterList(contractid) {
    return axios.get(`/api/Asset/RegisterList`, { params: { contractid } });
}

export function getContractAssets(companyid, projectid, contractid) {
  return axios.get(
    `/api/Asset/GetAssets?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}`
  );
}

export function getAsset(assetid) {
  return axios.get(
    `/api/Asset/GetAsset?assetid=${assetid}`
  );
}

export function getChained(contractid, assetid) {
  return axios.get(`/api/Asset/GetChained?contractid=${contractid}&assetid=${assetid}`);
}

export function importAssets(data, contractid) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Asset/Import?contractid=${contractid}`, data);
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function bulkDeactivate(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Asset/BulkDeactivate`, data);
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function bulkActivate(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Asset/BulkActivate`, data);
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}
